import dateFormat from "functions/dateFormat"
import AsyncTable from "components/AsyncTable"
import { Text, useDisclosure } from "@chakra-ui/react"
import { useSelector } from "react-redux"
import { State } from "state/reducers"
import DeleteUser from "./DeleteUser"
import StatusIndicator from "components/StatusIndicator"
import { useLazyPaginateUsers, usePaginateUsers } from "hooks/useUsers"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { userCreator } from "state/index"
import { cpfFormat } from "functions/maskFormats"
import { useState } from "react"

const header = [
    {
        label: 'Nome',
        acessor: 'name',
    },
    {
        label: 'E-mail',
        acessor: 'email',
    },
    {
        label: 'Cargo',
        acessor: 'role',
        custom: (value: any) => <Text>{value.name == "Super Admin" ? "Administrador" : value.name}</Text>
    },
    {
        label: 'Cadastrado em',
        acessor: 'created_at',
        custom: (value: string) => {
            const date = dateFormat(value)
            return <Text>{date}</Text>
        }
    },
]

const UsersTable = () => {
    const { loading, refetch } = usePaginateUsers();
    // const [repaginate, { loading: reloading }] = useLazyPaginateUsers()
    const [reloading, setReloading] = useState<boolean>(false);

    const { paginatorInfo, data } = useSelector(({ users }: State) => users)

    const onPaginationChange = async (page: number = 1, per_page: number = 30, search: string = '') => {
        setReloading(true);
        await refetch({
            page,
            first: per_page,
            search
        })
        setReloading(false);
    }

    return (
        <>
            <AsyncTable 
                isLoading={loading || reloading} 
                header={header} 
                per_page={paginatorInfo.perPage}
                current_page={paginatorInfo.currentPage}
                total={paginatorInfo.total}
                data={data}
                onPaginationChange={onPaginationChange}
                noDelete
                noView
            />
        </>
    )
}

export default UsersTable